<template>
  <div class="eds-task-agree-root">
    <v-textarea ref="refNote" :class="[{ 'hide-message': hiddenMessage }]" required :label="$t('请输入审批意见')"
      v-model="note" :clearable="true" solo flat auto-grow autofocus></v-textarea>
  </div>
</template>

<script>
import msgbus from '../../msgBus'
import { styleNo } from '../../config/BottomBtn'
import swal from 'sweetalert2'

export default {
  name: 'eDS-TaskAgree',
  components: {},
  data() {
    return {
      title: '',
      bottomButtons: [
        {
          primary: true,
          title: this.$t('确认同意'),
          style: styleNo[1],
          func: this.onConfirm,
          params: '',
          loading: false,
        },
      ],
      taskInfo: null,
      taskTid: '', // 任务所属租户tid
      note: '',
      rules: {
        required: (v) => !!v || this.$t('请输入审批意见'),
      },
      hiddenMessage: true,
    }
  },
  computed: {
  },
  methods: {
    //确认
    onConfirm() {
      if (!this.$refs.refNote.validate(true)) {
        this.hiddenMessage = false
        this.$refs.refNote.focus()
        return
      }

      msgbus.vm.setBottomBtnLoading({
        index: 0,
        flag: true,
      })

      msgbus.vm.taskApprove({
        tid: this.taskTid,
        taskID: this.taskInfo.id,
        data: this.note,
        vm: msgbus.vm,
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
      })
        .then(() => {
          swal.fire({
            text: '',
            title: this.$t('已同意申请'),
            type: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
          this.$router.back()
        })
        .catch((err) => {
          msgbus.vm.setBottomBtnLoading({
            index: 0,
            flag: false,
          })
          this.$router.back()
        })
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.title)
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(true)
      msgbus.vm.setBottomBtn({ value: this.bottomButtons })
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px - 36px ` + ')',
      })
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }

    // 读取路由参数：任务信息\任务所有租户tid
    this.taskInfo = this.$route.params.taskInfo
    this.taskTid = this.$route.params.taskTid
    this.title = msgbus.vm.isEDS16() ? this.taskInfo.workflowTitle : this.taskInfo.flowName

    // 切换界面样式
    this.changeView()
  },
  mounted() { },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>

<style lang="scss">
.eds-task-agree-root {
  height: 100%;

  &>.v-input {
    height: 100%;

    &>.v-input__control {
      height: 100%;
      display: flex;
      flex-direction: column;

      &>.v-input__slot {
        flex: 1;
        margin-bottom: 0;

        .v-text-field__slot {
          height: 100%;

          &>textarea {
            height: calc(100% - 12px) !important;
          }
        }
      }

      &>.v-text-field__details {
        flex: none;
      }
    }
  }

  .hide-message {
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
